import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useGetHousesQuery } from '../slices/housesApiSlice';
import { Link } from 'react-router-dom';
import House from '../components/House';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import Meta from '../components/Meta';


const Apphouse = () => {
  const { pageNumber, keyword } = useParams();
  const { data, isLoading, error } = useGetHousesQuery({
    keyword,
    pageNumber,
  });

  return (
    <>
      {keyword && (
        <Link to="/" className="btn btn-light mb-4">
          Go Back
        </Link>
      )}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || error.error}</Message>
      ) : (
        <>
          <Meta />
          <h1>Houses</h1>
          <Row>
            {data?.houses?.map((house) => (
              <Col key={house._id} sm={12} md={6} lg={4}>
                {/* Display House Details */}
                <div>
                  {/* Render House Component */}
                  <House house={house} />

                  {/* Display Multiple Images */}
                  {house.images?.length > 0 && (
                    <div className="mt-3">
                      <h6>Images:</h6>
                      <div>
                        {house.images.map((image, index) => (
                          <img
                            key={index}
                            src={image}
                            alt={`House ${index + 1}`}
                            style={{
                              width: '50px',
                              height: '50px',
                              marginRight: '5px',
                              borderRadius: '5px',
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </Col>
            ))}
          </Row>
          <Paginate pages={data.pages} page={data.page} keyword={keyword || ''} />
        </>
      )}
    </>
  );
};

export default Apphouse;